import { render, staticRenderFns } from "./SrLinkListGroup.vue?vue&type=template&id=16cfaf72"
import script from "./SrLinkListGroup.vue?vue&type=script&lang=js"
export * from "./SrLinkListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports